import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { ApiError, fetchJson } from "@/lib/api";

// Phase 2a /api/v1/account#me — used by the checkout shell to default
// the lessee/contact fields from the customer's saved profile. 401 is
// the anonymous-user case, which we surface as `data: null` rather
// than an error so the AccountSection still drives signup inline.

export interface CustomerProfileResponse {
  profile: {
    first_name: string | null;
    last_name: string | null;
    phone: string | null;
    company_name: string | null;
    preferred_notification_channel: string | null;
    default_address_id: number | null;
  };
}

export const PROFILE_QUERY_KEY = ["account", "profile"] as const;

export function useCustomerProfile(enabled: boolean): UseQueryResult<CustomerProfileResponse | null> {
  return useQuery({
    queryKey: PROFILE_QUERY_KEY,
    queryFn: async () => {
      try {
        return await fetchJson<CustomerProfileResponse>("/api/v1/account/me");
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    enabled,
    staleTime: 60_000,
    retry: 0
  });
}
